import { render, staticRenderFns } from "./dosion-accessory.vue?vue&type=template&id=2267fe41&"
import script from "./dosion-accessory.vue?vue&type=script&lang=js&"
export * from "./dosion-accessory.vue?vue&type=script&lang=js&"
import style0 from "./dosion-accessory.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports